import moment from "moment";

export default function renderAdrHeaderV3(data) {
  return function (pdf) {
    const splitProjWorkDesc = data.jobStamp.workDescription
      ? pdf.setFontSize(8).splitTextToSize(data.jobStamp.workDescription, 130)
      : [];
    const splitWeatherComm = data.weatherComment
      ? pdf.setFontSize(8).splitTextToSize(data.weatherComment, 107)
      : [];
    const splitOTReason = data.engineerOTReason
      ? pdf.setFontSize(8).splitTextToSize(data.engineerOTReason, 135)
      : [];
    let cursorY = this.cursorY;
    let cursorX = 0;
    let bottomOfHeader = 120;

    // Title block
    pdf.text("STATE OF CALIFORNIA - DEPARTMENT OF TRANSPORTATION", 15, 25);
    pdf.setFontSize(13).setFont("helvetica", "bold");
    pdf.text("ASSISTANT RESIDENT ENGINEER'S", 15, 38);
    pdf.text("DAILY REPORT", 15, 51);
    pdf.setFontSize(8).setFont("helvetica", "normal");
    pdf.text("CEM-4601 (CT ProDMS v" + data.version + ")", 15, 61);

    // Contractor list
    pdf
      .setFont("helvetica", "bold")
      .text("Contractor(s) This Shift:", 50, 83)
      .setFont("helvetica", "normal");

    cursorY = 94;
    let cLine = 0;
    if (data.contractors.length > 0) {
      for (cLine = 0; cLine < data.contractors.length; cLine++) {
        if (data.contractors[cLine] !== undefined) {
          pdf.text(data.contractors[cLine], 50, cursorY);
          cursorY += 11;
        }
      }
    } else {
      pdf.text("(None)", 50, cursorY);
    }
    if (cursorY > bottomOfHeader) bottomOfHeader = cursorY;

    pdf.line(260, 16, 400, 16); // jobStamp Top
    pdf.line(260, 16, 260, 115); // jobStamp Left
    pdf.line(400, 16, 400, 115); // jobStamp Right
    pdf.line(260, 115, 400, 115); // jobStamp Bottom
    pdf.setFont("helvetica", "bold");
    pdf.text("JOB STAMP", 330, 27, { align: "center" });
    pdf.setFont("helvetica", "normal");
    pdf.text(data.jobStamp.fullEA, 263, 38);
    pdf.text(data.jobStamp.distCoRtePm, 263, 49);
    pdf.text(data.jobStamp.efis || "", 263, 60);
    cursorY = 71;
    for (let currLine = 0; currLine < splitProjWorkDesc.length; currLine++) {
      if (currLine < 4) {
        pdf.text(splitProjWorkDesc[currLine], 263, cursorY);
        cursorY += 11;
      }
    }

    // Subcategory
    cursorY = 130;
    pdf.setFontSize(11).text("Subcat.:", 263, cursorY);
    pdf.text(data.customCategory, 306, cursorY);
    pdf.line(304, cursorY + 3, 400, cursorY + 3);
    pdf.setFontSize(8);

    cursorY = 25;
    // Author/Reviewer initials
    pdf.text("Written By:", 405, cursorY);
    pdf.text(data.writtenBy, 449, cursorY);
    pdf.line(446, cursorY + 2, 520, cursorY + 2); // x+40 for text, L=35

    // Page No
    pdf.text("Page", 533, cursorY);
    pdf.line(553, cursorY + 2, 568, cursorY + 2);
    pdf.text(pdf.internal.getNumberOfPages().toString(), 557, cursorY);
    pdf.text("of", 568, cursorY);
    pdf.line(575, cursorY + 2, 590, cursorY + 2);
    cursorY += 13;

    // ReportNo
    pdf.text("Reviewed By:", 405, cursorY);
    pdf.line(455, cursorY + 2, 520, cursorY + 2); // x+40 for text, L-35
    pdf.text("Rpt No:", 522, cursorY);
    pdf.text(data.reportNo.toString(), 553, cursorY);
    pdf.line(551, cursorY + 2, 590, cursorY + 2);

    cursorY += 13;
    // Dates
    pdf.text("Date:", 405, cursorY);
    pdf.text(moment(data.reportStartDate).format("MM/DD/YYYY (ddd)"), 447, cursorY);
    pdf.line(445, cursorY + 2, 520, cursorY + 2);
    pdf.text("Night Work:", 522, cursorY);
    pdf.text(data.isNightWork, 569, cursorY);

    cursorY += 13;
    // Weather
    pdf.text("Weather:", 405, cursorY);
    pdf.line(445, cursorY + 2, 520, cursorY + 2);
    pdf.text(data.weatherCondition, 447, cursorY);
    pdf.text("Temp:", 522, cursorY);
    pdf.text(data.lowTemp.toString(), 551, cursorY);
    pdf.line(546, cursorY + 2, 566, cursorY + 2);
    pdf.text("/", 568, cursorY);
    pdf.text(data.highTemp.toString(), 574, cursorY);
    pdf.line(569, cursorY + 2, 590, cursorY + 2);
    cursorY += 13;
    pdf.text("Weather Comments:", 405, cursorY);
    splitWeatherComm[0] && pdf.text(splitWeatherComm[0], 482, cursorY);
    pdf.line(480, cursorY + 2, 590, cursorY + 2);

    cursorY += 16;
    cursorX = 405;
    // Shift
    pdf.line(cursorX, cursorY - 10, cursorX + 135, cursorY - 10); // Horiz, top
    pdf.line(cursorX, cursorY - 10, cursorX, cursorY + 28); // Vert, left
    pdf.line(cursorX + 135, cursorY - 10, cursorX + 135, cursorY + 28); // Vert, right
    pdf.line(cursorX, cursorY + 28, cursorX + 135, cursorY + 28); // Horiz, bottom
    pdf.line(cursorX + 41, cursorY - 10, cursorX + 41, cursorY + 28); // Vert, mid left
    pdf.line(cursorX + 86, cursorY - 10, cursorX + 86, cursorY + 28); // Vert, mid right
    cursorX = 407;
    pdf.text("Shift", cursorX, cursorY);
    pdf.setFont("helvetica", "italic");
    pdf.text("Begin", cursorX + 42, cursorY);
    pdf.text("End", cursorX + 88, cursorY);
    pdf.line(cursorX - 2, cursorY + 3, cursorX + 133, cursorY + 3); // Horiz, mid top
    cursorY += 12;
    cursorX = 407;
    pdf.setFont("helvetica", "normal");
    pdf.text("Contractor", cursorX, cursorY);
    pdf.text(data.contractorStartShift, cursorX + 42, cursorY);
    pdf.text(data.contractorEndShift, cursorX + 88, cursorY);
    pdf.line(cursorX - 2, cursorY + 4, cursorX + 133, cursorY + 4); // Horiz, mid bot
    cursorY += 13;
    cursorX = 407;
    pdf.text("Engineer", cursorX, cursorY);
    pdf.text(data.engineerStartShift, cursorX + 42, cursorY);
    pdf.text(data.engineerEndShift, cursorX + 88, cursorY);
    cursorY += 13;
    pdf.text("Engineer OT:", 405, cursorY);
    splitOTReason[0] && pdf.text(splitOTReason[0], 455, cursorY);
    pdf.line(453, cursorY + 2, 590, cursorY + 2);
    cursorY += 4;

    if (cursorY > bottomOfHeader) bottomOfHeader = cursorY;

    bottomOfHeader += 4;
    // Bottom double-line border
    pdf.line(15, bottomOfHeader, 590, bottomOfHeader);
    pdf.line(15, bottomOfHeader + 2, 590, bottomOfHeader + 2);

    this._setDefaults(pdf);
    this.cursorY = bottomOfHeader;
    // console.log("cursorY after header=", cursorY);
  };
}
